module.exports = __webpack_public_path__ + "media/img/decorations/workers-img-right-2af0452fc580053f38f48bb3e33cc10f.svg";